import { lazy } from 'react';

import { RouteDefinition } from "./types";

const RegisterDocuments = lazy(() => import('../pages/Auth/Documents'));
const RegisterPortfolio = lazy(() => import('../pages/Auth/CreatePortfolio'));
const CompleteProfile = lazy(() => import('../pages/Auth/CompleteProfile'));
const CompleteProfileStart = lazy(() => import('../pages/Auth/CompleteProfileStart'));
const BookCall = lazy(() => import('../pages/Auth/BookCall'));
const CallVerified = lazy(() => import('../pages/Auth/CallVerified'));
const UserStatement = lazy(() => import('../pages/Auth/Documents/UserStatement'));
const UserLoanAgreement =  lazy(() => import('../pages/Auth/Documents/UserLoanAgreement'));

interface RegisterRouteDefinition extends RouteDefinition {
    wrapperClass?:string;
    step?:number;
};

export const registerroutes: RegisterRouteDefinition[] = [
    {
        component: CompleteProfileStart,
        exact: true,
        name: 'register-start',
        path: '/register/start',
        access: false,
        step: 1,
        wrapperClass: "page-welcome"
    },
    {
        component: CompleteProfile,
        exact: true,
        name: 'register-complete',
        path: '/register/complete',
        access: false,
        step: 1,
    },
    {
        component: RegisterDocuments,
        exact: true,
        name: 'register-documents',
        path: '/register/documents',
        access: false,
        step: 2
    },
    {
        component: BookCall,
        exact: true,
        name: 'book-call',
        path: '/register/book-call',
        access: false,
        step: 3
    },
    {
        component: UserStatement,
        exact: true,
        name: 'user-statement',
        path: '/register/statement',
        parent: 'documents',
        access: false,
        step: 3
    },
    {
        component: UserLoanAgreement,
        exact: true,
        name: 'user-loan-agreement',
        path: '/register/loan-agreement',
        parent: 'documents',
        access: false,
        step: 3
    },
    // {
    //     component: CompleteProfile,
    //     exact: true,
    //     name: 'user-kyc',
    //     path: '/register/kyc',
    //     parent: 'documents',
    //     access: false,
    //     step: 3
    // },

    {
        component: CallVerified,
        exact: true,
        name: 'call-verified',
        path: '/register/call-verified',
        access: false,
        step: 4
    },
    {
        component: RegisterPortfolio,
        exact: true,
        name: 'register-portfolio',
        path: '/register/portfolio',
        access: false,
        step: 4
    },
];
